/* Whether the tideline is open.
 *
 * One boolean, in a module, because two things set it and they are in different
 * component trees: the tideline's own PASSES toggle, and the time panel's "open
 * the tideline" button. A `bind:` between them would mean threading it through
 * `AppShell`, which has no business knowing this app has a tideline at all.
 */
class TidelineState {
  /** Shut by default on every viewport. Opened with three gate lanes it is
   *  ~190 px — 21% of a 900 px window for a control most of a session does not
   *  touch, which is the same budget failure the phone's dock was refactored to
   *  fix when it came to 124 px. */
  collapsed = $state(true);
}

export const tideline = new TidelineState();
